import { render, staticRenderFns } from "./ModalListaConfiguracaoPonto.vue?vue&type=template&id=a22c4026"
import script from "./ModalListaConfiguracaoPonto.vue?vue&type=script&lang=js"
export * from "./ModalListaConfiguracaoPonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports